import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { tseServiceUrl } from '../../../../urls'

const headers = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
}

const tseInstance = axios.create({
	baseURL: tseServiceUrl,
	headers,
})

tseInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

tseInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default tseInstance
